module.exports = __webpack_public_path__ + "media/customizations/tehaleh/back-0034dcc4fdcf61d1d35d4f5d2d739410.jpg";